import { customInspectionTypeSettings } from '../../common/src/domain/customInspectionTypes/customInspectionTypeSettings';
import { InspectionStandardTypes } from '../../common/src/enums/InspectionStandardTypes';
import { FeatureFlags } from '../../common/src/FeatureFlags';
import { hasFeatureFlag } from './utils/hasFeatureFlag';
import { isCustomerVersion } from './utils/isCustomerVersion';

export function getInspectionStandardTypes() {
    let result: string[] = [];
    if (isCustomerVersion('ronik')) {
        result = [
            InspectionStandardTypes.Fmeca,
            InspectionStandardTypes.Memo,
            InspectionStandardTypes.Nen2767,
            InspectionStandardTypes.Model3d,
            InspectionStandardTypes.Api653,
            InspectionStandardTypes.Api570,
            InspectionStandardTypes.Eemua159,
            InspectionStandardTypes.Free,
        ];
    } else if (isCustomerVersion('zxy') || isCustomerVersion('rws')) {
        result = [
            InspectionStandardTypes.Model3d,
            customInspectionTypeSettings.nen3140!.inspectionStandardType,
            customInspectionTypeSettings.droneLabel!.inspectionStandardType,
            InspectionStandardTypes.Fmeca,
            InspectionStandardTypes.Memo,
            customInspectionTypeSettings.rovLabel!.inspectionStandardType,
            InspectionStandardTypes.Nen2767,
            InspectionStandardTypes.Free,
            customInspectionTypeSettings.crowBeeldkwaliteit!.inspectionStandardType,
            customInspectionTypeSettings.verificatieBerekening!.inspectionStandardType,
        ];
    } else if (isCustomerVersion('hyperplane') || isCustomerVersion('intures') || isCustomerVersion('aquasmart')) {
        result = [InspectionStandardTypes.Model3d, InspectionStandardTypes.Memo, InspectionStandardTypes.Nen2767, InspectionStandardTypes.Free];
    } else if (
        isCustomerVersion('rijksvastgoed') ||
        isCustomerVersion('utrecht') ||
        isCustomerVersion('amsterdam') ||
        isCustomerVersion('rotterdam')
    ) {
        result = [
            InspectionStandardTypes.Model3d,
            InspectionStandardTypes.Memo,
            InspectionStandardTypes.Nen2767,
            customInspectionTypeSettings.nen3140!.inspectionStandardType,
            InspectionStandardTypes.Free,
        ];
    } else {
        throw new Error('Unknown customer version.');
    }

    if (hasFeatureFlag(FeatureFlags.AmsterdamOverspanningen)) {
        result = [
            ...result,
            customInspectionTypeSettings.aoBasisgegevens!.inspectionStandardType,
            customInspectionTypeSettings.aoInspectieOverspanningen!.inspectionStandardType,
        ];
    }

    return result;
}

export function getInspectionStandardTypeOptions(translate: (key: string) => string) {
    return getInspectionStandardTypes().map((i) => ({ value: i, text: translate(`inspectionStandard.${i}`) }));
}
